import { getUserLocale } from 'get-user-locale';
import { ESupportedLanguages, type SupportedLanguage } from '@krishanmadan/core/src/model/const';

export const languageDefault = function languageDefault(): SupportedLanguage {
  const language = getUserLocale();
  if (`${language}`.toLowerCase() === 'it') {
    return ESupportedLanguages.it;
  }
  if (`${language}`.toLowerCase() === 'italian') {
    return ESupportedLanguages.it;
  }
  if (`${language}`.toLowerCase() === 'italiano') {
    return ESupportedLanguages.it;
  }
  if (`${language}`.toLowerCase() === 'italy') {
    return ESupportedLanguages.it;
  }

  return ESupportedLanguages.en;
}();
